import { useState } from "react";
import { Link } from "react-router-dom";
import Footer from "@/components/site/Footer";
import BookingSidebar from "@/components/site/BookingSidebar";
import hero from "@/assets/tour-cambodia-25day-sunset.jpg";

const itinerary = [
  { time: "7:30 AM – 5:30 PM", title: "Sunrise at Angkor Wat  Angkor Thom, Bayon & Ta Prohm", body: "Begin in Siem Reap with sunrise at Angkor Wat, the south gate of Angkor Thom, the Bayon and tree-clad Ta Prohm. Overnight: 4–5★ hotel in Siem Reap." },
  { time: "8:00 AM – 5:30 PM", title: "Banteay Srei & Grand Circuit", body: "Pink sandstone carvings of Banteay Srei and the Grand Circuit temples. Overnight: Siem Reap." },
  { time: "8:00 AM – 2:00 PM", title: "Kampong Phluk & Tonlé Sap", body: "Boat trip to the stilt-house village of Kampong Phluk on Tonlé Sap. Overnight: Siem Reap." },
  { time: "7:30 AM – 5:30 PM", title: "Phnom Kulen National Park", body: "1000 Lingas riverbed, the Giant Buddha and the waterfall. Overnight: Siem Reap." },
  { time: "7:30 AM – 6:30 PM", title: "Beng Mealea & Koh Ker", body: "Jungle ruin of Beng Mealea and the seven-tiered pyramid of Koh Ker. Overnight: Siem Reap." },
  { time: "7:30 AM – 5:30 PM", title: "Kampong Kleang Fishing Village", body: "Day at the largest stilt village on Tonlé Sap. Overnight: Siem Reap." },
  { time: "7:30 AM – 5:30 PM", title: "Banteay Chhmar & Spean Toap", body: "Drive west to remote Banteay Chhmar via the ancient bridge of Spean Toap. Overnight: eco-lodge near Banteay Chhmar." },
  { time: "7:00 AM – 6:00 PM", title: "Preah Vihear Hilltop Temple", body: "UNESCO cliff-edge temple of Preah Vihear. Overnight: guesthouse in Preah Vihear." },
  { time: "8:00 AM – 5:00 PM", title: "Sambor Prei Kuk", body: "Pre-Angkorian brick towers in the forest. Overnight: hotel in Kampong Thom." },
  { time: "8:00 AM – 5:00 PM", title: "Preah Khan Kampong Svay", body: "Vast remote temple complex of Preah Khan of Kampong Svay. Overnight: Kampong Thom." },
  { time: "8:00 AM – 6:00 PM", title: "Transfer to Battambang", body: "Countryside drive south to Battambang. Overnight: 4★ hotel in Battambang." },
  { time: "8:00 AM – 6:00 PM", title: "Bamboo Train, Pottery & Killing Caves", body: "Bamboo Train, pottery village, the Killing Caves and sunset bats. Overnight: Battambang." },
  { time: "8:00 AM – 5:00 PM", title: "Cycling & Cooking Class", body: "Battambang countryside cycling and a Khmer cooking class. Overnight: Battambang." },
  { time: "8:00 AM – 5:00 PM", title: "Pailin Day Trip", body: "Pailin gem town and Khmer Rouge historical sites. Overnight: Battambang." },
  { time: "7:30 AM – 3:00 PM", title: "Transfer to Phnom Penh", body: "Drive to the capital with a riverside walk in the evening. Overnight: 4–5★ hotel in Phnom Penh." },
  { time: "8:00 AM – 5:00 PM", title: "Royal Palace, Silver Pagoda & National Museum", body: "The royal complex and Cambodia's greatest collection of Khmer sculpture. Overnight: Phnom Penh." },
  { time: "8:00 AM – 5:00 PM", title: "Killing Fields, Tuol Sleng & Russian Market", body: "A sober day at Choeung Ek and S-21, then the Russian Market. Overnight: Phnom Penh." },
  { time: "8:00 AM – 4:00 PM", title: "Silk Island & Mekong Cruise", body: "Silk Island, a Mekong island cruise and a street food walking tour. Overnight: Phnom Penh." },
  { time: "7:00 AM – 6:00 PM", title: "Transfer to Kratie & Irrawaddy Dolphins", body: "Drive to Kratie and afternoon boat to see the rare Mekong dolphins. Overnight: riverside hotel in Kratie." },
  { time: "8:00 AM – 5:00 PM", title: "Koh Trong Island Cycling", body: "Cycle around Koh Trong island and visit fishing communities. Overnight: Kratie." },
  { time: "7:00 AM – 6:00 PM", title: "Transfer to Mondulkiri", body: "Drive into the highlands of Mondulkiri and explore Sen Monorom. Overnight: eco-lodge." },
  { time: "8:00 AM – 5:00 PM", title: "Elephant Sanctuary & Bou Sra Waterfall", body: "Ethical elephant sanctuary visit and trek to Bou Sra waterfall. Overnight: eco-lodge." },
  { time: "7:00 AM – 6:00 PM", title: "Transfer to Ratanakiri", body: "Cross to the red-earth highlands and Banlung town. Overnight: eco-lodge in Ratanakiri." },
  { time: "8:00 AM – 5:00 PM", title: "Yeak Laom Lake & Indigenous Villages", body: "Volcanic crater lake of Yeak Laom and indigenous village visits. Overnight: Ratanakiri." },
  { time: "7:00 AM – 5:00 PM", title: "Fly Back to Phnom Penh", body: "Domestic flight from the highlands back to the capital. Overnight: 4–5★ hotel in Phnom Penh." },
  { time: "7:30 AM – 4:00 PM", title: "Transfer to Kampot Pepper & Caves", body: "Drive south to Kampot, visit a famous pepper plantation and limestone caves. Overnight: 4★ boutique hotel in Kampot." },
  { time: "8:00 AM – 5:00 PM", title: "Bokor Mountain, Salt Fields & Firefly Cruise", body: "Bokor Mountain hill station, salt fields and a firefly river cruise at dusk. Overnight: Kampot." },
  { time: "8:00 AM – 3:00 PM", title: "Kep Crab Market, Rabbit Island & Coast", body: "Kep crab market, optional Rabbit Island and transfer to Sihanoukville. Overnight: 4★ beach resort." },
  { time: "Free Day", title: "Koh Rong / Koh Rong Sanloem", body: "Ferry to the islands for snorkeling, beach time and bioluminescent plankton after dark. Overnight: beach bungalow." },
  { time: "8:00 AM – 3:00 PM", title: "Return & Airport Transfer", body: "Ferry back to the mainland and transfer to Phnom Penh Airport for your onward flight." },
];

const Timeline = ({ items }: { items: typeof itinerary }) => (
  <ol className="space-y-px">
    {items.map((s, idx) => (
      <li
        key={idx}
        className="group grid grid-cols-[auto_1fr] md:grid-cols-[200px_1fr] gap-x-4 md:gap-x-12 min-w-0 border-t border-border py-8 md:py-10 transition-colors hover:bg-secondary/40 last:border-b"
      >
        <div className="flex flex-col items-start gap-y-2 text-base">
          <span className="font-display text-primary tabular-nums text-xl">
            {String(idx + 1).padStart(2, "0")}
          </span>
          <span className="uppercase tracking-[0.25em] text-primary text-xs md:text-base">
            {s.time}
          </span>
        </div>
        <div>
          <h3 className="font-display text-2xl md:text-3xl leading-tight mb-3 transition-colors group-hover:text-primary">
            {s.title}
          </h3>
          <p className="text-muted-foreground font-light leading-relaxed text-lg max-w-2xl">
            {s.body}
          </p>
        </div>
      </li>
    ))}
  </ol>
);

const optionOne = {
  label: "Option 1 — Transport Only",
  pricePrivate: "$3,215 – $3,890 total (1–2 pax)",
  priceGroup: "$3,215 per person",
  includes: [
    "Air-conditioned transportation",
    "Hotel pickup and drop-off",
    "Complimentary bottled water & cold towels",
    "Photography guidance",
  ],
  excludes: [
    "Professional guide",
    "All accommodation & meals",
    "Personal expenses & travel insurance",
  ],
};

const optionTwo = {
  label: "OPTION 2 ALL-INCLUSIVE",
  pricePrivate: "$8,000 – $9,500 total (1–2 pax)",
  priceGroup: "$4,000 per person",
  includes: [
    "All accommodation — 4–5★ hotels & eco-lodges",
    "All entrance fees",
    "Professional English-speaking guide",
    "Air-conditioned transportation",
    "All meals (lunch Day 2–30, select dinners)",
    "4 dinner shows with traditional Khmer dance",
    "Domestic flights where applicable",
    "All activity fees (elephant sanctuary, boat trips, etc.)",
  ],
  excludes: ["Tips and gratuities", "Personal expenses", "Travel insurance"],
};

const TourCambodia30Day = () => {
  const [option, setOption] = useState(0);
  const opt = option === 0 ? optionOne : optionTwo;
  return (
    <main className="bg-background">
      {/* HERO */}
      <header className="relative bg-jungle text-background overflow-hidden">
        <img
          src={hero}
          alt="Cambodia 30 day ultimate private tour — coastal sunset with French-speaking guide, from Angkor to Koh Rong"
          width={1920}
          height={1280}
          className="absolute inset-0 h-full w-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-jungle/70 via-jungle/50 to-jungle/95" />
        <div className="relative z-10">
          <div className="container flex items-center justify-between py-6">
            <Link to="/" className="flex items-center gap-2">
              <span className="font-display text-2xl tracking-wide">Aṅkor</span>
              <span className="text-[10px] uppercase tracking-[0.3em] opacity-70">Sojourns</span>
            </Link>
            <Link to="/tours" className="text-[11px] uppercase tracking-[0.3em] border-b border-background/40 pb-1 hover:border-primary hover:text-primary transition-colors">
              ← All Tours
            </Link>
          </div>
          <div className="container pt-20 pb-32 md:pt-28 md:pb-44 max-w-5xl">
            <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Thirty-Day Ultimate Adventure</p>
            <h1 className="font-display text-5xl md:text-7xl leading-[0.95] text-balance lg:text-2xl">
              A Month in the <em className="font-light">Kingdom</em> — every province, every experience, the complete Cambodia.
            </h1>
            <p className="mt-10 max-w-xl text-background/70 leading-relaxed text-xl font-light">
              The most comprehensive Cambodia tour available. Over 2 days, explore every major region — from the legendary temples of Angkor to the remote northeast highlands, the cultural heartland of Battambang, the vibrant capital and pristine southern beaches.
            </p>
            <div className="mt-10 flex flex-wrap gap-x-10 gap-y-3 text-[11px] uppercase tracking-[0.3em] text-background/80">
              <span>Duration · 30 Days</span>
              <span>Group · 1–8</span>
              <span>From $3,215 / pax</span>
            </div>
          </div>
        </div>
      </header>

      {/* INTRO */}
      <section className="py-24 md:py-32">
        <div className="container max-w-4xl">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— The Idea</p>
          <h2 className="font-display text-4xl leading-[1.05] mb-10 text-balance md:text-xl">
            Every province, every experience — Cambodia at its fullest.
          </h2>
          <div className="space-y-6 text-lg font-light text-muted-foreground leading-relaxed">
            <p>
              A full month spanning Angkor and Tonlé Sap, the cliff temple of Preah Vihear and the moated ruins of Banteay Chhmar, the pre-Angkorian brick of Sambor Prei Kuk, Battambang and Pailin, the capital and the Mekong river towns, the elephant forests of Mondulkiri, the volcanic lakes of Ratanakiri, the pepper coast of Kampot and Kep, and finally the bioluminescent waters of Cambodia's southern islands.
            </p>
          </div>
        </div>
      </section>

      {/* ITINERARY */}
      <section className="pb-24 md:pb-32">
        <div className="container max-w-6xl"><div className="grid lg:grid-cols-[1fr_420px] gap-x-12 gap-y-12 items-start"><div>
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Itinerary</p>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.05] mb-16 text-balance">
            Thirty days, day by day.
          </h2>
          <Timeline items={itinerary} />
        </div><BookingSidebar pricePerPerson={3215} tourTitle="30-Day Ultimate Cambodia Adventure" pricingTiers={[{ maxPax: 2, price: 3215 }, { maxPax: 6, price: 3567 }, { maxPax: 10, price: 3890 }]} /></div></div>
      </section>

      {/* PRICING TABS */}
      <section className="bg-secondary py-24 md:py-32">
        <div className="container max-w-5xl">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Pricing &amp; Inclusions</p>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.05] mb-12 text-balance">
            Choose your level of comfort.
          </h2>

          <div role="tablist" aria-label="Pricing options" className="flex flex-wrap justify-center gap-10 md:gap-16 mb-16">
            {[optionOne, optionTwo].map((o, i) => {
              const isActive = i === option;
              return (
                <button
                  key={o.label}
                  role="tab"
                  aria-selected={isActive}
                  onClick={() => setOption(i)}
                  className={`relative pb-3 uppercase tracking-[0.3em] transition-colors text-base ${
                    isActive ? "text-foreground" : "text-muted-foreground hover:text-foreground"
                  }`}
                >
                  {o.label}
                  <span
                    className={`absolute left-0 right-0 -bottom-px h-px transition-colors ${
                      isActive ? "bg-primary" : "bg-transparent"
                    }`}
                  />
                </button>
              );
            })}
          </div>

          <ul className="mb-12 space-y-4 font-light text-lg max-w-3xl mx-auto">
            <li className="border-b border-border pb-4 flex justify-between gap-6"><span>Private Tour (2 Days)</span><span className="text-right">{opt.pricePrivate}</span></li>
            <li className="pb-4 flex justify-between gap-6"><span>Group Tour</span><span className="text-right">{opt.priceGroup}</span></li>
          </ul>

          <div className="grid md:grid-cols-2 gap-x-12 gap-y-12">
            <div>
              <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Includes</p>
              <ul className="space-y-4 font-light text-lg">
                {opt.includes.map((x) => (
                  <li key={x} className="border-b border-border pb-4 last:border-b-0">{x}</li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Excludes</p>
              <ul className="space-y-4 font-light text-lg">
                {opt.excludes.map((x) => (
                  <li key={x} className="border-b border-border pb-4 last:border-b-0">{x}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* WHAT TO BRING */}
      <section className="py-24 md:py-32">
        <div className="container max-w-5xl">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Essential Items</p>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.05] mb-16 text-balance">What to bring, what to leave behind.</h2>
          <div className="grid md:grid-cols-3 gap-x-10 gap-y-12">
            <div>
              <h3 className="font-display text-2xl mb-5">Required</h3>
              <ul className="space-y-3 font-light text-muted-foreground">
                <li>Modest clothing &amp; sturdy hiking shoes</li>
                <li>Insect repellent (essential)</li>
                <li>Light rain jacket &amp; swimwear</li>
                <li>Medications &amp; first aid kit</li>
              </ul>
            </div>
            <div>
              <h3 className="font-display text-2xl mb-5">Recommended</h3>
              <ul className="space-y-3 font-light text-muted-foreground">
                <li>Camera with extra batteries</li>
                <li>Small daypack</li>
                <li>Reusable water bottle</li>
                <li>Sun protection hat, sunscreen</li>
              </ul>
            </div>
            <div>
              <h3 className="font-display text-2xl mb-5">Leave at Hotel</h3>
              <ul className="space-y-3 font-light text-muted-foreground">
                <li>Passport (bring a copy)</li>
                <li>Airline tickets</li>
                <li>Excess cash</li>
                <li>Valuable jewellery</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* GOOD TO KNOW */}
      <section className="bg-secondary py-24 md:py-32">
        <div className="container max-w-4xl">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Good to Know</p>
          <div className="space-y-6 text-lg font-light text-muted-foreground leading-relaxed">
            <p><span className="text-foreground">Weather.</span> Diverse climate zones — hot lowlands, cool highlands and breezy coast. Be prepared for all conditions.</p>
            <p><span className="text-foreground">Food.</span> Experience the full range of Cambodian cuisine — from royal Khmer dishes to street food, fresh seafood and ethnic minority specialties.</p>
            <p>Good fitness level required for trekking days. Some remote areas have basic accommodation. Domestic flights are included for long transfers.</p>
            <p>Children under 5 are not permitted. Maximum group size: 1–8 travellers.</p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 md:py-32">
        <div className="container max-w-3xl text-center">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Reserve Your Journey</p>
          <h2 className="font-display text-4xl md:text-6xl leading-[1.05] mb-10 text-balance">
            Thirty days. The complete Cambodia, coast to highland.
          </h2>
          <Link
            to="/#contact"
            className="inline-block bg-foreground text-background px-10 py-4 text-[11px] uppercase tracking-[0.3em] hover:bg-primary transition-colors"
          >
            Book Now →
          </Link>
        </div>
      </section>
      <Footer />
    </main>
  );
};

export default TourCambodia30Day;
